/**
 * THE SWITCH-OVER (owner 2026-11-03, prepared on branch redesign/switch-over): the new design for everyone.
 * true = every switchboard line that was "legacy" serves the new page (switchboard.ts), the public pages are the new ones
 * (public/mode.ts PUBLIC_MODE) and the new frame is everyone's (shell/frameMode.ts FRAME_RELEASED).
 * Roll back everything: false (then build and deploy). Roll back one page: write `mode: "legacy"` on its line instead of `atRelease(...)`
 * (the My team four lines go together, with ACCESS_NEW_ACCOUNTS_MODEL: RELEASE-CHECKLIST §4).
 * Staff can still see today's pages with "Show the old version" (preview/legacyView.ts) and the public ones with ?legacy=<code>.
 *
 * Tests: src/setupTests.ts pins this to false, so the suites keep testing both sides by flipping lines themselves as before;
 * next/__tests__/switchOver.test.ts checks the real value.
 */
export const SWITCHED_OVER: boolean = true;

/** A line's mode: "next" once switched over, else what it was before the release. */
export const atRelease = (before: "legacy" | "next"): "legacy" | "next" => (SWITCHED_OVER ? "next" : before);
